import { downloadApiFile, req } from "./transport";

export const privacyApi = {
  // Increment 40: data rights (export + account deletion)
  async dataStatus() {
    return req<{ deletion: { scheduled: boolean; scheduledAt: string | null; requestedAt: string | null; graceDays: number; activeDisputeCount: number } }>("/data/status");
  },

  async createDataExport() {
    return req<{ ok: boolean; export: { id: string; token: string; status: string; sizeBytes: number }; downloadPath: string }>("/data/export", { method: "POST" });
  },

  async downloadDataExport(path: string, id: string) {
    return downloadApiFile(path.replace(/^\/api/, ""), `kontrataph-data-${id}.html`, "Could not download your export. Please retry.");
  },

  dataExportUrl(path: string) {
    // path already begins with /api/... ; strip the /api prefix since API_BASE adds it
    return (((import.meta as any).env?.VITE_API_ORIGIN ?? "").replace(/\/+$/, "")) + path;
  },

  async scheduleAccountDeletion(reason?: string) {
    return req<{ ok: boolean; scheduledAt: string; graceDays: number }>("/data/delete-account", { method: "POST", body: JSON.stringify(reason ? { reason } : {}) });
  },

  async cancelAccountDeletion() {
    return req<{ ok: boolean }>("/data/delete-account/cancel", { method: "POST" });
  }
};
